import React, {createRef, ReactElement, RefObject} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from '../../Toolkit/Components/Controls/Table';
import MButton from '../../Toolkit/Components/Controls/Button';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import {MNewIconName, MOpenIconName} from '../../Toolkit/Icons';
import FileUploadDialog from '../Dialogs/FileUploadDialog';
import MSpacer from '../../Toolkit/Components/Controls/Spacer';
import {DataTableSortMeta} from 'primereact/datatable';
import EnumContext from '../../Context/enum-context';
import {Registration} from '../../Api/RegistrationTypes';
import WithRouterProps from '../../Toolkit/WithRouterProps';

export type RegistrationRow = {
    data: Registration;
}

type RouteParams = {}


type Props = WithRouterProps<RouteParams> & {
    noticeId: number;
    rowData: RegistrationRow[];
}

/** */
type State = {
    filters: MTableFilters;
    selectedRow?: RegistrationRow;
}

class FileListControl extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private readonly m_uploadRef: RefObject<FileUploadDialog>;

    public constructor(props: Props) {
        super(props);

        this.m_uploadRef = createRef<FileUploadDialog>();

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
        this.new_Click = this.new_Click.bind(this);
        this.edit_Click = this.edit_Click.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
    }

    private initializeState(): void {
        this.state = {
            filters: {}
        };
    }

    private table_onSelectionChange(selection: RegistrationRow | RegistrationRow[] | undefined): void {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as RegistrationRow | undefined);

    }

    private new_Click(): void {
        this.props.navigate(`/registrations/create/${this.props.noticeId}`);
    }

    private edit_Click(): void {
        this.props.navigate(`/registrations/${this.state.selectedRow!.data.id}`);
    }

    private tableSortTemplate(): DataTableSortMeta[] {
        return [
            {field: 'data.digNumber', order: 1},
        ];
    }

    public render(): ReactElement {
        return (
            <div>
                <MToolbar>
                    <MButton label="Add"
                             color="success"
                             icon={MNewIconName}
                             disabled={false}
                             onClick={this.new_Click}/>
                    <MSpacer/>
                    <MButton label="Open"
                             icon={MOpenIconName}
                             disabled={this.state.selectedRow === null}
                             onClick={this.edit_Click}/>
                </MToolbar>
                <MTable
                    rowKey="data.id"
                    rowData={this.props.rowData}
                    filters={this.state.filters}
                    onSelectionChange={this.table_onSelectionChange}
                    sortMode={'multiple'}
                    multiSortMeta={this.tableSortTemplate()} >

                    <Column field="data.digNumber"
                            header="Dig Number"
                            filter={false}
                            sortable={true}
                            style={{width: '15%'}}/>
                    <Column field="data.digLocation"
                            header="Dig Location"
                            filter={false}
                            sortable={true}
                            style={{width: '85%'}}/>
                </MTable>
            </div>
        );
    }
}

export default FileListControl;